// extracted by mini-css-extract-plugin
export default {"modal":"_2RoZ8___Modal-module__modal"};